import { takeLatest, put, call } from 'redux-saga/effects';
import * as OrderActions from './actions';
import * as OrderService from '../../../api/OrderService';
import i18n from '../../../i18n/i18n';
import type { Effect } from 'redux-saga/effects';

export function* handleFetchOrders(): Generator<Effect, void, any> {
  try {
    const response = yield call(OrderService.getOrders);
    const {
      data: { orders },
    } = response;
    yield put(OrderActions.fetchOrdersSuccess(orders));
  } catch (err) {
    const error = err as any;
    const message = error?.response?.data?.error?.message;
    yield put(
      OrderActions.fetchOrdersFail(
        message?.[i18n.getLang()] || 'Error occurred fetching orders',
      ),
    );
  }
}

export function* watchFetchOrders() {
  yield takeLatest(OrderActions.FETCH_ORDERS, handleFetchOrders);
}
